export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0A192F] text-white/70 py-10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="font-display italic text-lg text-white">
          Melina Marketing
        </div>
        <p className="text-xs uppercase tracking-[0.25em]">
          © {new Date().getFullYear()} — Hecho con dedicación en Buenos Aires
        </p>
      </div>
    </footer>
  );
}
